import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import BundleTypeBar from 'components/common/BundleTypeBar';
import Content from 'components/Content';
import SearchKeywords from 'components/common/SearchKeywords';
import BuyButton from 'components/BuyButton';
import * as Const from 'util/constants';
import { Link } from 'react-router-dom';
import { asyncFetchBundle } from 'actions/bundles';
import { priceRegular, priceRegularInit, pricePremium, pricePremiumInit } from 'actions/order';
import './ImageBundle.scss';
import rainbowNoticeImage from 'images/rainbow-notice.png';
import iconBW from 'images/ic-bw.png';
import iconColor from 'images/ic-color.png';

import AssetThumbnail from 'components/common/AssetThumbnail';

export class ImageBundle extends Component {
  state = {
    preview: null
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    const { fetchBundle } = this.props;
    fetchBundle(id);
  }

  componentDidUpdate(prevProps, prevState) {
    this.syncTitle();
    this.syncDescription();
    ReactTooltip.rebuild();
  }

  syncTitle() {
    const { bundle } = this.props;
    if (bundle) {
      let title = `Doodly: ${bundle.name} SVG doodle images`;
      if (this.state.preview) {
        title += ` - ${this.state.preview.title}`;
      }
      document.title = title;
    }
  }

  syncDescription() {
    const { bundle } = this.props;
    if (bundle) {
      let description = `The ${bundle.name} svg bundle comes complete with ${this.getTags(5, 1).join(
        ', '
      )} and much more.`;

      const descriptionEl = document.querySelector('meta[name="description"]');
      if (descriptionEl) {
        descriptionEl.setAttribute('content', description);
      } else {
        const descriptionEl = document.createElement('meta');
        descriptionEl.setAttribute('name', 'description');
        descriptionEl.setAttribute('content', description);
        document.head.append(descriptionEl);
      }
    }
  }

  getTags(count = 0, per_keyword = 2) {
    const { bundle } = this.props;
    const tags =
      bundle && bundle.assets
        ? Array.from(
            new Set(
              bundle.assets.flatMap(
                asset =>
                  (asset.tags || '')
                    .split('.')
                    .join(',')
                    .split(',')
                    .map(s => s.trim())
                    .slice(0, per_keyword) // get first tag from each asset (to ensure better coverage)
              )
            )
          )
        : [];

    if (count) {
      return tags.slice(0, count);
    } else {
      return tags;
    }
  }

  previewAsset = asset => {
    this.setState({
      preview: asset
    });
  };

  render() {
    const { bundle, query, homeQuery } = this.props;
    const { preview } = this.state;
    // const category = bundle ? categories.find(c => c.id === parseInt(bundle.categ_id)) : null;
    const keywords = this.getTags();

    return (
      <div className="image-bundle d-flex flex-column">
        <Header className={Const.TYPE_IMAGE_BUNDLES} />
        <Content className={Const.TYPE_IMAGE_BUNDLES}>
          <div className="d-flex justify-content-start">
            <BundleTypeBar className={Const.TYPE_IMAGE_BUNDLES} />
          </div>
          {bundle && (
            <div className="breadcrumbs">
              <Link to={`/home/${homeQuery}`}>Home</Link>
              <span className="sep">&gt;</span>
              {!bundle.is_purchased ? (
                <Link to={`/${Const.TYPE_IMAGE_BUNDLES}/${query}`}>Images</Link>
              ) : (
                <Link to={`/my-purchases/${Const.TYPE_IMAGE_BUNDLES}`}>My Purchases</Link>
              )}
              <span className="sep">&gt;</span>
              {bundle.name}
            </div>
          )}
          {bundle && !bundle.is_purchased && (
            <div className="rainbow-notice d-flex align-items-center">
              <img src={rainbowNoticeImage} alt="" className="mr-4 d-none d-md-inline-block" />
              <div className="notice">
                <b>
                  <span className="important mr-2">Important Note:</span> You will need the{' '}
                  <a href="https://www.doodly.com/rainbow/" target="_blank" rel="noopener noreferrer">
                    Doodly Rainbow addon
                  </a>{' '}
                  to get/use the colored version of each image.
                </b>
                <p className="mt-2 mb-0">
                  Each bundle comes with
                  <img src={iconBW} alt="" />
                  50 black and white versions AND
                  <img src={iconColor} alt="" />
                  50 color versions (if you have the Doodly Rainbow addon) of each image.
                </p>
              </div>
            </div>
          )}
          <div className="sheet">
            {bundle ? (
              <>
                <div className="row">
                  <div className="col-lg-6 thumbnails">
                    <AssetThumbnail
                      className="large thumb"
                      image={preview ? preview.rainbow_path || preview.path : bundle.thumb_path}
                      watermarked={preview && !bundle.is_purchased ? true : false}
                      style={{ backgroundSize: preview ? 'contain' : 'cover' }}
                      alt={bundle.name}
                    />
                    <div className="d-flex justify-content-between flex-wrap">
                      {bundle.assets &&
                        bundle.assets.map((asset, i) => (
                          <AssetThumbnail
                            className="small thumb"
                            image={asset.rainbow_path || asset.path}
                            key={i}
                            onClick={this.previewAsset.bind(this, asset)}
                            title={asset.title}
                          />
                        ))}
                      <div className="small thumb clear"></div>
                      <div className="small thumb clear"></div>
                      <div className="small thumb clear"></div>
                      <div className="small thumb clear"></div>
                      <div className="small thumb clear"></div>
                    </div>
                  </div>
                  <div className="col-lg-6 details">
                    <h2>{bundle ? bundle.name : 'Loading...'}</h2>
                    {!bundle.is_purchased && (
                      <div className="d-flex align-items-center buy">
                        <div className="d-flex align-items-start price">
                          ${bundle.is_premium ? pricePremium : priceRegular}
                          <span className="init-price">${bundle.is_premium ? pricePremiumInit : priceRegularInit}</span>
                        </div>
                        <BuyButton productId={bundle.clickFunnelsProductId} productType="image" />
                      </div>
                    )}
                    <div className="caption">{preview ? preview.title : ' '}</div>
                    <div className="description">
                      {bundle.description.split('\n').map((line, i) => (
                        <p key={i}>{line}</p>
                      ))}
                    </div>
                    <div className="notice d-none d-lg-block">
                      Click a thumbnail image to the left to see a preview.
                    </div>
                  </div>
                </div>
                {!bundle.is_purchased && (
                  <div className="row">
                    <div className="col-12 related">
                      <h3>Related keywords</h3>
                      <SearchKeywords keywords={keywords} type={Const.TYPE_IMAGE_BUNDLES} />
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center">
                <i className="loading fas fa-spinner fa-spin" />
              </div>
            )}
          </div>
        </Content>
        <Footer />
        <ReactTooltip effect="solid" />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { home, bundles } = state;
  return {
    bundle: bundles.currentBundle,
    query: bundles.searchFor || '', // get the query used in Image bundles page
    homeQuery: home.searchFor || '' // get the query used in Home page
  };
};

const mapDispatchToProps = dispatch => ({
  fetchBundle: bundleId => dispatch(asyncFetchBundle(bundleId, 'image'))
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageBundle);
